import { cva, type VariantProps } from 'class-variance-authority';
import mergeClasses from 'shared/lib/utils';
const skeletonVariant = cva('animate-pulse rounded-md', {
  variants: {
    variant: {
      default: 'bg-muted',
      dark: 'bg-accent-dark'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export type SkeletonVariant = VariantProps<typeof skeletonVariant>;
interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof skeletonVariant> {}
function Skeleton({
  className,
  variant,
  ...props
}: SkeletonProps) {
  return <div className={mergeClasses(skeletonVariant({
    variant
  }), className)} {...props} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx" />;
}
export { Skeleton };